import {
  Heading,
  Text,
  Box,
  Card,
  CardHeader,
  CardBody,
} from "@chakra-ui/react";
import DoubleColumn from "../../molecules/DoubleColumn";
import { useSelector } from "react-redux";
import useProgrammi from "../../../utils/hooks/useProgrammi";
import { getProgrammaData } from "../../../store/programma/selectors";
import { TalesProgramma } from "../../../utils/types/TalesProgramma";
import AvailableSoon from "../../molecules/AvailableSoon";

export default function Programma() {
  useProgrammi();
  const programmi = useSelector(getProgrammaData);

  function createCard(programma: TalesProgramma) {
    return (
      <Card>
        <CardHeader>
          <Heading size="md">{programma.title}</Heading>
          <Heading size="base">{programma.subtitle}</Heading>
        </CardHeader>
        <CardBody>
          {programma.events.map((e) => {
            if (e.show) {
              return (
                <Box key={e.title} mb={"20px"}>
                  <Heading size="base">{e.title}</Heading>
                  {e.details.map((d) => {
                    if (d.show) {
                      return (
                        <Text key={`${d.ora} ${d.description}`}>
                          {d.ora} · {d.description}
                        </Text>
                      );
                    } else {
                      return null;
                    }
                  })}
                </Box>
              );
            } else {
              return null;
            }
          })}
        </CardBody>
      </Card>
    );
  }

  return (
    <>
      {((programmi?.length === 0 ?? true) ||
        !programmi?.some((programma) => programma.show)) && <AvailableSoon />}
      {programmi &&
        programmi.some((p) => p.highlight && p.show) &&
        programmi.map((programma) => {
          if (programma.show && programma.highlight) {
            return <Box mb="20px">{createCard(programma)}</Box>;
          } else {
            return null;
          }
        })}
      <DoubleColumn>
        {programmi &&
          programmi.some((p) => p.show && !p.highlight) &&
          programmi.map((programma) => {
            if (programma.show && !programma.highlight) {
              return createCard(programma);
            } else {
              return null;
            }
          })}
      </DoubleColumn>
    </>
  );
}
